/**
 * Traducao das sinalizacoes que o backend devolve como `GENERAL_ERROR`.
 *
 * O SuperTokens usa `GENERAL_ERROR` como canal de mensagens da aplicacao, e o
 * SDK entrega o texto cru — que sao codigos internos como
 * `USER_MIGRATION_FAILED`, escritos para log e nao para leitura. Sem esta camada
 * eles chegam a tela exatamente assim.
 */
const AUTH_MESSAGES: Record<string, string> = {
  USER_MIGRATED_SUCCESSFULLY:
    "Sua conta foi migrada. Enviamos um e-mail para você criar uma nova senha.",
  USER_MIGRATION_FAILED:
    "Não foi possível migrar sua conta antiga. Entre em contato com o suporte.",
  SUPERTOKENS_SIGNUP_FAILED:
    "Não foi possível migrar sua conta antiga. Entre em contato com o suporte.",
  SUPERTOKENS_RESET_EMAIL_FAILED:
    "Sua conta foi migrada, mas o e-mail para criar a nova senha não pôde ser enviado. Use \"Esqueci minha senha\" ou fale com o suporte.",
  MIGRATION_LOOKUP_FAILED:
    "Não foi possível verificar seu cadastro agora. Tente novamente em alguns instantes.",
  PASSWORD_RESET_NOT_ALLOWED:
    "Não é possível redefinir a senha desta conta. Entre em contato com o suporte.",
  TOO_MANY_SIGNIN_ATTEMPTS:
    "Muitas tentativas de login. Aguarde alguns minutos e tente novamente.",
};

/**
 * Um codigo que ainda nao esta no mapa acima nao pode vazar para a tela so por
 * ser desconhecido — e o que aconteceria a cada sinalizacao nova criada no
 * backend. O formato SCREAMING_SNAKE_CASE identifica esses casos.
 */
function looksLikeInternalCode(value: string): boolean {
  return /^[A-Z][A-Z0-9]*(_[A-Z0-9]+)+$/.test(value.trim());
}

export function translateAuthMessage(
  rawMessage: string | undefined | null,
  fallback: string,
): string {
  const message = rawMessage?.trim();
  if (!message) return fallback;

  const translated = AUTH_MESSAGES[message];
  if (translated) return translated;

  return looksLikeInternalCode(message) ? fallback : message;
}
